/* import __COLOCATED_TEMPLATE__ from './phone-field.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './phone-field.module.scss';

@classic
@classNames(styles.component)
export default class RequestInformationInfoFormPhoneField extends Component {}
